/* eslint-disable import/prefer-default-export */
import { globalDataApi } from '../globalDataApi';

const pointsEndpoints = globalDataApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getPoints: query({
      query: () => ({
        url: 'get-points',
      }),
    }),
  }),
});

export const { useGetPointsQuery } = pointsEndpoints;
